import { render, staticRenderFns } from "./ImageEditor.vue?vue&type=template&id=0c1dffab&scoped=true&"
import script from "./ImageEditor.vue?vue&type=script&lang=ts&"
export * from "./ImageEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ImageEditor.vue?vue&type=style&index=0&id=0c1dffab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1dffab",
  null
  
)

export default component.exports